import { REPORT_TIME_SPENT_EVENT } from '../constants/expertReportTrackingEvents'
import type { ReportSession, ReportTrackingEvent } from '../types/expertReportTracking'

export const getReportTimeSpentEvent = (session: ReportSession, now: number): ReportTrackingEvent => ({
  name: REPORT_TIME_SPENT_EVENT,
  organization: session.organization,
  /* eslint-disable @typescript-eslint/naming-convention -- Segment payload keys are snake_case */
  payload: {
    duration_seconds: Math.round((now - session.enteredAt) / 1000),
    period_type: session.periodType,
    report_type: session.reportType,
  },
  /* eslint-enable @typescript-eslint/naming-convention */
})
